import type PerformanceMonitor from "./monitoring/PerformanceMonitor";

/**
 *
 * Returns a function that can wrap a async func and measure time taken
 * @param {PerformanceMonitor}
 * @returns {Function}
 */
const makeMeasure = (monitor: PerformanceMonitor) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async function measure<F extends(...args: any[]) => any>(
        this: unknown,
        name: string,
        fn: F,
        ...args: Parameters<typeof fn>): Promise<Awaited<ReturnType<F>>> {
        const metric = monitor.createMetric(name);

        metric.start();
        try {
            return await fn.apply(this, args);
        } catch (error) {
            metric.mark("error", { error: error && error.toString().slice(0, 500) });
            throw error;
        } finally {
            metric.end();
        }
    };

export default makeMeasure;
